/* RESPONSIBLE TEAM: team-messenger */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  primaryKey: 'token',
});
